<template>
  <v-container fluid class="fixedasset-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Fixed Asset</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Asset</p>
                        <v-text-field
                          class="mb-4"
                          v-model="fixedasset.assetcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Asset Code"
                          persistent-hint
                          single-line hint="Enter the asset code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="fixedasset.assetname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Asset Name"
                          persistent-hint
                          single-line hint="Enter the asset name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=assettypes
                          v-model="fixedasset.assettype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Asset Type"
                          persistent-hint
                          single-line hint="Please choose the asset type">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items=deptypes
                          v-model="fixedasset.deptype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Depreciation Type"
                          persistent-hint
                          single-line hint="Please choose the depreciation type">
                        </v-select>
                        <v-text-field
                          type="number"
                          class="mb-4"
                          v-model="fixedasset.depyears"
                          outlined
                          dense
                          placeholder="Depreciation Years"
                          persistent-hint
                          single-line hint="Enter the depreciation years">
                        </v-text-field>
                        <v-text-field
                          type="number"
                          class="mb-4"
                          v-model="fixedasset.deprate"
                          outlined
                          dense
                          placeholder="Depreciation Rate"
                          persistent-hint
                          single-line hint="Enter the depreciation rate">
                        </v-text-field>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/fixedasset/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertFixedAsset()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      fixedasset: {},
      deptypes: ['Straight Line', 'Declining Balance'],
      assettypes: ['Land', 'Building', 'Factory', 'Equipment & Machinery', 'Furniture & Fixture', 'Computer & Software', 'Vehicle'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('FixedAsset', ['insertFixedAssetRequest', 'getFixedAssetsRequest']),
    ...mapActions('Account', ['getAccountsRequest']),
    checkError(){
      if(!this.fixedasset.assetcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.fixedasset.assetname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.fixedasset.assettype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async insertFixedAsset() {
      if(!this.checkError()) return;
      await this.insertFixedAssetRequest(this.fixedasset);
      this.getFixedAssetsRequest();
      router.push('/fixedasset/list');
    },
  },
  computed: {
    ...mapState('FixedAsset', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
